import { FC, PropsWithChildren } from 'react';

export const EmptyWrapper: FC<PropsWithChildren> = ({ children }) => {
  return <>{children}</>;
};
